class OosSuggestionsDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = document.querySelector('.PageOverlay');
    this.heading = this.querySelector('[data-oos-heading]');
    this.sizeLabel = this.querySelector('[data-oos-size-label]');
    this.suggestionsSlot = this.querySelector('[data-oos-suggestions-slot]');
    this.notifyCta = this.querySelector('[data-oos-notify-cta]');
    this.currentBisButton = null;

    this._attachListeners();
  }

  _attachListeners() {
    document.addEventListener('click', this._onSizeClick.bind(this), true);
    document.addEventListener('click', this._onBodyClick.bind(this));
    document.addEventListener('keyup', this._onKeyUp.bind(this));

    if (this.notifyCta) {
      this.notifyCta.addEventListener('click', this._onNotifyCtaClick.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        if (this.isOpen()) this.close();
      });
    }
  }

  isOpen() {
    return this.getAttribute('aria-hidden') === 'false';
  }

  open(context) {
    this.currentBisButton = context.bisButton;
    if (this.heading) this.heading.textContent = 'Size ' + context.size + ' is Out of Stock';
    if (this.sizeLabel) this.sizeLabel.textContent = 'size ' + context.size;

    if (context.bisButton) {
      context.bisButton.setAttribute('selected-variant', context.variantId);
    }

    this.savedScrollY = window.scrollY;
    this.savedScrollX = window.scrollX;

    this._loadSuggestions(context.productUrl, context.variantId);
    this.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll', 'drawer-opened');
    if (this.overlay) this.overlay.classList.add('is-visible');
  }

  close() {
    if (this.contains(document.activeElement) && document.activeElement.blur) {
      document.activeElement.blur();
    }
    this.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll', 'drawer-opened');
    if (this.overlay) this.overlay.classList.remove('is-visible');
    const savedY = this.savedScrollY;
    const savedX = this.savedScrollX || 0;
    if (typeof savedY === 'number') {
      requestAnimationFrame(() => { window.scrollTo(savedX, savedY); });
    }
  }

  _findContext(target) {
    if (this.contains(target)) return null;

    const sizeLabel = target.closest('.SizeSwatch.disabled');
    if (sizeLabel) return this._fromPdpSizeLabel(sizeLabel);

    const qbButton = target.closest('.quick-buy-desktop__button[data-sold-out]');
    if (qbButton) return this._fromPlpQuickBuy(qbButton);

    return null;
  }

  _fromPdpSizeLabel(label) {
    const inputId = label.htmlFor || label.getAttribute('for');
    const input = inputId ? document.getElementById(inputId) : null;
    const variantId = input ? input.getAttribute('data-variantid') : null;
    if (!variantId) return null;

    const bisButton = document.querySelector('back-in-stock-button.product-form__notify-me');
    if (!bisButton) return null;

    const size = (label.getAttribute('data-variantsize') || label.textContent || '').trim();
    return { bisButton, variantId, size, productUrl: window.location.pathname, isPlp: false };
  }

  _fromPlpQuickBuy(button) {
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return null;

    const wrapper = button.closest('quick-buy-desktop');
    if (!wrapper) return null;
    const bisButton = wrapper.querySelector('back-in-stock-button');
    if (!bisButton) return null;

    const size = (button.textContent || '').trim();

    let productUrl = window.location.pathname;
    const productItem = button.closest('product-item, [data-product-item]');
    if (productItem) {
      const link = productItem.querySelector('[data-product-item-link]')
                || productItem.querySelector('a[href*="/products/"]');
      if (link) {
        productUrl = link.getAttribute('href').split('?')[0].split('#')[0];
      }
    }

    return { bisButton, variantId, size, productUrl, isPlp: true };
  }

  _onSizeClick(e) {
    const ctx = this._findContext(e.target);
    if (!ctx) return;

    ctx.bisButton.setAttribute('selected-variant', ctx.variantId);

    const hasOosSuggestions = ctx.bisButton.getAttribute('data-has-oos-suggestions') === 'true';

    if (ctx.isPlp) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    if (hasOosSuggestions) {
      this.open(ctx);
    } else {
      const innerBtn = ctx.bisButton.querySelector('.bis-button');
      if (innerBtn) innerBtn.click();
    }
  }

  _loadSuggestions(productUrl, variantId) {
    if (!this.suggestionsSlot) return;
    this.suggestionsSlot.innerHTML = '';
    const url = `${productUrl}?variant=${encodeURIComponent(variantId)}&section_id=oos-suggestions`;
    fetch(url, { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const container = doc.querySelector('.shopify-section') || doc.body;
        if (!container.querySelector('.OosDrawer__Card')) {
          this.close();
          const innerBtn = this.currentBisButton && this.currentBisButton.querySelector('.bis-button');
          if (innerBtn) innerBtn.click();
          return;
        }
        this.suggestionsSlot.innerHTML = container.innerHTML;
      })
      .catch(() => {});
  }

  _onBodyClick(e) {
    const closer = e.target.closest('[data-action="close-drawer"]');
    if (closer && this.contains(closer)) this.close();
  }

  _onKeyUp(e) {
    if (e.key === 'Escape' && this.isOpen()) this.close();
  }

  _onNotifyCtaClick() {
    if (!this.currentBisButton) return;
    const template = this.currentBisButton.querySelector('[data-bis-modal-content]');
    if (!template) return;
    const content = template.content.firstElementChild.cloneNode(true);
    const variantId = this.currentBisButton.getAttribute('selected-variant');
    const matchingOption = content.querySelector(`[value="${variantId}"]`);
    if (matchingOption) matchingOption.setAttribute('selected', '');
    document.dispatchEvent(new CustomEvent('drawer-modal:open', {
      detail: { html: content.outerHTML },
    }));
  }
}

if (!customElements.get('oos-suggestions-drawer')) {
  customElements.define('oos-suggestions-drawer', OosSuggestionsDrawer);
}
